import './LoadingScreen.css';

export default function LoadingScreen() {
  const dark = (() => {
    try {
      const u = JSON.parse(localStorage.getItem('usuario')) || {};
      return u.tema === 'escuro';
    } catch { return false; }
  })();

  return (
    <div className={`ls ${dark ? 'ls--dark' : 'ls--light'}`}>
      <div className="ls__card">
        <div className="ls__logo">
          <span className="ls__logo-i">i</span>
          <span className="ls__logo-text">Studo</span>
        </div>

        <div className="ls__bars">
          <span /><span /><span /><span />
        </div>

        <p className="ls__label">Carregando sua plataforma…</p>
      </div>
    </div>
  );
}
